import { render, staticRenderFns } from "./input-tags.vue?vue&type=template&id=ebc47e4c"
import script from "./input-tags.vue?vue&type=script&lang=js"
export * from "./input-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports